<template>
  <div class="org-account">
    <headBox title="账号设置">
      <el-button slot="btn-list" class="org-btn small add-btn" @click="$refs.editForm.open()">新增</el-button>
    </headBox>
    <div class="content">
      <el-form class="select-form-new follow" :inline="true">
        <el-form-item label="登录账号">
          <el-input v-model="searchParams.account" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchParams.mobile" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <div class="btn-box">
          <el-button class="org-btn small" @click="searchAjax()">查询</el-button>
        </div>
      </el-form>
        
      <el-table border :data="tableData" style="width: 100%" class="list-table" tooltip-effect="dark">
        <el-table-column property="account" min-width="140" label="登录账号"></el-table-column>
        <el-table-column property="name" min-width="140" label="登录名称"></el-table-column>
        <el-table-column property="mobile" min-width="140" label="手机号"></el-table-column>
        <el-table-column property="useStatus" min-width="110" label="状态">
          <template slot-scope="{row}">
            <span class="tag3 green" v-if="row.useStatus==1">启用</span>
            <span class="tag3 red" v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column property="roleName" min-width="140" label="角色名称"></el-table-column>
        <el-table-column label="创建时间" min-width="160">
          <template slot-scope="scope">
            <span>{{scope.row.createTime|timeSubstr(0,16)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width='180'>
          <template slot-scope="{row}">
            <el-button-group class="line-btn-box">
              <el-button type="text" size='small' @click="$refs.editForm.open(row)">编辑</el-button>
              <el-button type="text" size='small' @click="$refs.setRole.open(row)" v-if="row.useStatus==1">变更角色</el-button>
              <el-tooltip class="item" effect="dark" content="此账号已禁用，不可变更角色" placement="top" v-else>
                <el-button type="text" size='small' class="disabled">变更角色</el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
        <emptyBox slot="empty"></emptyBox>
      </el-table>
      <el-pagination
        class="page"
        background
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :layout="$tools.pageLayout"
        :total="total"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        @current-change="getList"
      ></el-pagination>
    </div>

    <!-- 新增/编辑角色 -->
    <edit-form ref="editForm" @reload="searchAjax()"></edit-form>
    <!-- 新增/编辑角色 -->
    <set-role ref="setRole" @reload="searchAjax()"></set-role>
  </div>
</template>
<script>
import headBox from "@/components/head.vue";
import { pageTool } from "@/api/mixins";
import editForm from "./components/editForm.vue";
import setRole from "./components/setRole.vue";
export default {
  mixins: [pageTool],
  components: {
    setRole,
    editForm,
    headBox,
  },
  data: () => ({
    tableData: [],
    searchParams: {
    },
  }),
  activated(){
    this.getList();
  },
  mounted() {
    this.initListAjax("/master/mechanUser/read/list");
  },
  methods: {
    goTemplateUserList(item){
      this.$http({
        url: "/master/commissonTemplate/queryDetail",
        type: "put",
        params: {id: item.id}
      }).then((res)=> {
        this.$refs.templateUserList.open(res.data)
      });
    },
    goDetail(item){
      this.$router.push({
        path:"/orgManage/feeTemplateDetail",
        query:{
          id:item.id
        }
      })
    },
    del(item){
      this.$confirm('确定删除模板?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass:"new-confirm",
      }).then(() => {
        this.$http({
          url:'/master/commissonTemplate/delete',
          type:'DELETE',
          params:{
            id:item.id,
          },
        }).then(res=>{
          this.$message.success("模板删除成功");
          this.searchAjax();
        })
      })
    },
    setListParams(params) {
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/components/topSearchForm";
.org-account {
  .content {
    padding: 20px;
    background: #fff;
    .list-table {
      .info-text {
        font-size: 12px;
        color: #A8ADB7;
      }
      .link-text {
        cursor: pointer;
        color: $baseColor;
        text-decoration: underline;
      }
    }
  }
}
</style>

